import _extends from "@babel/runtime/helpers/extends";
import { Box, Divider, Text } from '@wix/design-system';
import React from 'react';
import { getWdsSurfaceNeutralProps } from '../../../utils/wds-theme-colors';
/**
 * Visible AI disclaimer strip.
 * Use `footer` for panel footers (includes trailing divider).
 * Use `inline` inside task content where surrounding chrome owns dividers.
 * For screen-reader-only disclaimers, use `AiNotification` with `aiMistakesText`.
 */
export const AiDisclaimerBanner = _ref => {
  let {
    text,
    variant = 'footer',
    dataHook
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: dataHook,
    direction: "horizontal",
    padding: "SP2 SP3",
    textAlign: "center",
    width: "100%"
  }, getWdsSurfaceNeutralProps()), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, text)), variant === 'footer' && /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=ai-disclaimer-banner.js.map